import ImageSlider from "../Parallax Slider/ImageSlider";

// Importing data
import { latestProjects } from "../../assets/documents/config";

const RenderProjects = () => {
    return <ImageSlider options={{ dragFree: true, loop: true }} slides={latestProjects} />
}

export default RenderProjects;
